import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-theme-provider-energiedirect-light',
  standalone: true,
  styleUrl: './theme-provider-energiedirect-light.component.scss',
  template: '<ng-content />',
})
export class ThemeProviderEnergiedirectLightComponent {}
